/******************************************************************************
 *** MbrasChangeTypeDialog ** 변경 구분 선택
 *******************************************************************************/
import AppContext from "@/js/common/AppContext";
import Button from "@/js/common/ui/Button";
import RadioBox from "@/js/common/ui/input/RadioBox";
import Util from "@/js/common/Util";
import React from "react";

const MbrasChangeTypeDialog = (props: any) => {
    const { selectedMember, setModalStep, setMbrasAtrzSeCd } = props;

    const [selectedChangeCd, setSelectedChangeCd] = React.useState("");

    const member = selectedMember;
    const isWithdraw = member.mbrasJoinSttsCd === "03";

    const renderValue = (value: string) => {
        return Util.isEmpty(value) ? "-" : value;
    };

    const changeTypeList = React.useMemo(() => {
        const codeList = Util.getCodeArray("MBRAS_ATRZ_SE_CD")
            .filter((item: any) => ["04", "05", "06", "07", "08", "09", "10", "11"].includes(item.code));

        const joinSttsCd = member.mbrasJoinSttsCd;

        // 가입 조합원
        if (joinSttsCd === "01") {
            return codeList.filter((item: any) =>
                ["04", "05", "06", "09", "10"].includes(item.code)
                && !(member.lbrShpSeCd === "01" && item.code === "04") // 정규직은 정규직 전환 제외
            );
        }

        // 휴직 조합원
        if (joinSttsCd === "02") {
            return codeList.filter((item: any) => ["07", "08", "09", "10"].includes(item.code));
        }

        // 탈퇴 조합원
        if (joinSttsCd === "03") {
            return codeList.filter((item: any) => item.code === "11");
        }

        return [];
    }, [member.mbrasJoinSttsCd, member.lbrShpSeCd]);

    const changeTypeRows = React.useMemo(() => {
        const rows: any[][] = [];

        for (let i = 0; i < changeTypeList.length; i += 2) {
            rows.push(changeTypeList.slice(i, i + 2));
        }

        return rows;
    }, [changeTypeList]);

    const selectChangeType = () => {
        if (Util.isEmpty(selectedChangeCd)) {
            AppContext.openAlert({
                title: "변경 구분 확인",
                msg  : "변경 구분을 선택해주세요.",
                icon : "warning",
            });
            return;
        }

        setMbrasAtrzSeCd(selectedChangeCd);

        switch (selectedChangeCd) {
            case "04":
                setModalStep("REGUL");          // 정규직 전환 신청
                break;
            case "05":
                setModalStep("DEPART");         // 소속변경 신청
                break;
            case "06":
                setModalStep("LEAVE");          // 휴직 신청
                break;
            case "07":
                setModalStep("LEAVE_EXTEND");   // 휴직 연장 신청
                break;
            case "08":
                setModalStep("RETURN");         // 복직 신청
                break;
            case "09":
                setModalStep("RESIGN");         // 의원면직 신청
                break;
            case "10":
                setModalStep("RETIRE");         // 퇴직 신청
                break;
            case "11":
                setModalStep("REJOIN");         // 재가입 신청
                break;
            default:
                AppContext.openAlert({
                    title: "변경 구분 확인",
                    msg  : "선택한 변경 구분을 확인해주세요.",
                    icon : "warning",
                });
                break;
        }
    };

    return (
        <div className="w540 p15">
            {/* 조합원 정보 */}
            <div className="mb20">
                <div className="dpFlx aiC gap8 mb10 fm-b fs15 fc111827 ls06">
                    <span className="w4 h16 bdrd2 bgc007bff" />
                    조합원 정보
                </div>

                <div
                    className="bd1 bdcDDDDDD bdrd10 ofH bgcWhite"
                    style={{ boxShadow: "0 5px 16px rgba(31, 41, 55, 0.04)" }}
                >
                    {isWithdraw ? (
                        <>
                            {/* 1행 */}
                            <div className="dpFlx bdb1 bdcDDDDDD">
                                <div className="dpFlx flx1">
                                    <div className="w100 h46 dpFlx aiC jcC bsBdb pl12 pr12 bgcFAFAFA fm-b fs13 fc4B5563 ls06 bdr1 bdcDDDDDD">
                                        성명
                                    </div>
                                    <div className="flx1 h46 dpFlx aiC bsBdb pl18 pr18 bgcWhite fm-c fs14 fc222222 ls06">
                                        {renderValue(member.mbrasNm)}
                                    </div>
                                </div>

                                <div className="dpFlx flx1 bdl1 bdcDDDDDD">
                                    <div className="w100 h46 dpFlx aiC jcC bsBdb pl12 pr12 bgcFAFAFA fm-b fs13 fc4B5563 ls06 bdr1 bdcDDDDDD">
                                        본부
                                    </div>
                                    <div className="flx1 h46 dpFlx aiC bsBdb pl18 pr18 bgcWhite fm-c fs14 fc222222 ls06">
                                        {renderValue(Util.getUpOrgName(member.upOgnzCd))}
                                    </div>
                                </div>
                            </div>

                            {/* 2행 */}
                            <div className="dpFlx">
                                <div className="dpFlx flx1">
                                    <div className="w100 h46 dpFlx aiC jcC bsBdb pl12 pr12 bgcFAFAFA fm-b fs13 fc4B5563 ls06 bdr1 bdcDDDDDD">
                                        지부
                                    </div>
                                    <div className="flx1 h46 dpFlx aiC bsBdb pl18 pr18 bgcWhite fm-c fs14 fc222222 ls06">
                                        {renderValue(Util.getDownOrgName(member.ogdpOrgCd))}
                                    </div>
                                </div>

                                <div className="dpFlx flx1 bdl1 bdcDDDDDD">
                                    <div className="w100 h46 dpFlx aiC jcC bsBdb pl12 pr12 bgcFAFAFA fm-b fs13 fc4B5563 ls06 bdr1 bdcDDDDDD">
                                        관내
                                    </div>
                                    <div className="flx1 h46 dpFlx aiC bsBdb pl18 pr18 bgcWhite fm-c fs14 fc222222 ls06">
                                        {renderValue(member.wtjrNm)}
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : (
                        <>
                            {/* 1행 */}
                            <div className="dpFlx bdb1 bdcDDDDDD">
                                <div className="dpFlx flx1">
                                    <div className="w100 h46 dpFlx aiC jcC bsBdb pl12 pr12 bgcFAFAFA fm-b fs13 fc4B5563 ls06 bdr1 bdcDDDDDD">
                                        성명
                                    </div>
                                    <div className="flx1 h46 dpFlx aiC bsBdb pl18 pr18 bgcWhite fm-c fs14 fc222222 ls06">
                                        {renderValue(member.mbrasNm)}
                                    </div>
                                </div>

                                <div className="dpFlx flx1 bdl1 bdcDDDDDD">
                                    <div className="w100 h46 dpFlx aiC jcC bsBdb pl12 pr12 bgcFAFAFA fm-b fs13 fc4B5563 ls06 bdr1 bdcDDDDDD">
                                        전화번호
                                    </div>
                                    <div className="flx1 h46 dpFlx aiC bsBdb pl18 pr18 bgcWhite fm-c fs14 fc222222 ls06">
                                        {renderValue(Util.setPhoneNum(member.telno))}
                                    </div>
                                </div>
                            </div>

                            {/* 2행 */}
                            <div className="dpFlx">
                                <div className="dpFlx flx1">
                                    <div className="w100 h46 dpFlx aiC jcC bsBdb pl12 pr12 bgcFAFAFA fm-b fs13 fc4B5563 ls06 bdr1 bdcDDDDDD">
                                        생년월일
                                    </div>
                                    <div className="flx1 h46 dpFlx aiC bsBdb pl18 pr18 bgcWhite fm-c fs14 fc222222 ls06">
                                        {renderValue(Util.cvtDateStrForm(member.brdtDate, "-", "YYYYMMDD"))}
                                    </div>
                                </div>

                                <div className="dpFlx flx1 bdl1 bdcDDDDDD">
                                    <div className="w100 h46 dpFlx aiC jcC bsBdb pl12 pr12 bgcFAFAFA fm-b fs13 fc4B5563 ls06 bdr1 bdcDDDDDD">
                                        성별
                                    </div>
                                    <div className="flx1 h46 dpFlx aiC bsBdb pl18 pr18 bgcWhite fm-c fs14 fc222222 ls06">
                                        {renderValue(Util.getValToCode("GNDR_CD", member.gndrCd))}
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>

            <div className="dpFlx aiC gap8 mb10 fm-b fs15 fc111827 ls06">
                <span className="w4 h16 bdrd2 bgc007bff" />
                변경구분
            </div>

            <div className="bd1 bdcDDDDDD bdrd6 p20">
                {changeTypeList.length > 0 ? (
                    <div>
                        {changeTypeRows.map((row, index) => (
                            <div
                                key={index}
                                className={index > 0 ? "mt12" : ""}
                            >
                                <RadioBox
                                    codeList={row}
                                    value={selectedChangeCd}
                                    setValue={setSelectedChangeCd}
                                    btnColor="#007bff"
                                    btnSize={16}
                                    btnClass=""
                                    labelClass="ml8 fm-c fs15 fc333333 wsNw"
                                    interval={20}
                                    singleWidth={220}
                                    flexDirection="row"
                                />
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="fm-c fs14 fc666666 taC">
                        선택 가능한 변경 구분이 없습니다.
                    </div>
                )}
            </div>

            <div className="dpFlx jcC gap10 mt20">
                <Button
                    width={90}
                    height={40}
                    fontFamily="fm-b"
                    fontSize={15}
                    letterSpacing={-1}
                    variant="styCancelBtn"
                    borderRadius={6}
                    buttonClass="dpFlx aiC jcC"
                    buttonName="이전"
                    onClickFunc={() => setModalStep("MEMBER_SEARCH")}
                />

                <Button
                    width={100}
                    height={40}
                    fontFamily="fm-b"
                    fontSize={15}
                    letterSpacing={-1}
                    variant="styCompleteBtn"
                    borderRadius={6}
                    buttonClass="dpFlx aiC jcC"
                    buttonName="다음"
                    onClickFunc={selectChangeType}
                />
            </div>
        </div>
    );
};

export default MbrasChangeTypeDialog;